module.exports = __webpack_public_path__ + "static/media/background.29ce22be.jpg";